export interface AssistantConfig {
  apiBaseUrl: string;
  streamPath: string;
  userId: string;
}

let overrideConfig: Partial<AssistantConfig> = {};

export function getConfig(): AssistantConfig {
  const envApiBaseUrl = process.env.REACT_APP_AI_ASSISTANT_API_BASE_URL;
  const envStreamPath = process.env.REACT_APP_AI_ASSISTANT_STREAM_PATH;
  const envUserId = process.env.REACT_APP_AI_ASSISTANT_USER_ID;

  return {
    apiBaseUrl:
      overrideConfig.apiBaseUrl ??
      (envApiBaseUrl !== undefined ? envApiBaseUrl : ''),
    streamPath:
      overrideConfig.streamPath ??
      (envStreamPath !== undefined
        ? envStreamPath
        : '/api/v1/agent-core/invoke/stream'),
    userId:
      overrideConfig.userId ??
      (envUserId !== undefined ? envUserId : 'anonymous')
  };
}

export function setConfig(cfg: Partial<AssistantConfig>) {
  overrideConfig = { ...overrideConfig, ...cfg };
}

export function getStreamUrl(): string {
  const { apiBaseUrl, streamPath } = getConfig();

  if (!apiBaseUrl) {
    return streamPath;
  }

  if (/^https?:\/\//.test(streamPath)) {
    return streamPath;
  }

  if (
    apiBaseUrl.endsWith(streamPath) ||
    apiBaseUrl.endsWith('/invoke/stream')
  ) {
    return apiBaseUrl;
  }

  return `${apiBaseUrl.replace(/\/$/, '')}/${streamPath.replace(/^\//, '')}`;
}
